import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorLoggingService } from './error-logging.service';

@Injectable()
export class ErrorLoggingInterceptor implements HttpInterceptor {
  constructor(private errorLogging: ErrorLoggingService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isLoggingEndpoint(req.url)) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse | unknown) => {
        this.errorLogging.logError(error, 'http', { url: req.url, method: req.method });
        return throwError(() => error);
      })
    );
  }

  private isLoggingEndpoint(url: string): boolean {
    return url.includes('/frontend-error');
  }
}
